import * as React from "react";
import styled from "@emotion/styled";

interface MiniProgressProps {
  circleRef: React.MutableRefObject<SVGCircleElement | null>;
  radius: number;
}

export const MiniProgress: React.FC<MiniProgressProps> = (
  props: MiniProgressProps
) => {
  const { circleRef, radius } = props;
  return (
    <SVG
      width="58"
      height="58"
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        ref={circleRef}
        data-testid="mini-progress-circle"
        className="mini-progress-circle"
        cx="29"
        cy="29"
        r={radius}
        strokeWidth="4.25"
        fill="transparent"
        stroke="#00d4a2"
      />
    </SVG>
  );
};

const SVG = styled.svg({
  position: "absolute",
  pointerEvents: "none",
  transform: "translate(-3px, -3px)",
});
